import { lazy } from 'react';
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import PrivateRoute from './PrivateRoute';   // ✅ import here
// import Message from "pages/message/index";
import Account from "pages/account/index";
import FeatureInProgress from '../pages/in-progress/featureInProgress';
import UsersPage from '../pages/users';
import PlatformPage from '../pages/platform';
import AdminPlans from '../pages/plans/admin_plans';
import GeneralPlans from '../pages/plans/general_plans';
import Profile from '../pages/profile';

// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));

// render - color
const Color = Loadable(lazy(() => import('pages/component-overview/color')));
const Typography = Loadable(lazy(() => import('pages/component-overview/typography')));
const Shadow = Loadable(lazy(() => import('pages/component-overview/shadows')));
const SchedulePostsDefault = Loadable(lazy(() => import('pages/schedule-posts/index')));
const Instagram = Loadable(lazy(() => import('pages/schedule-posts/instagram')));
const YouTube = Loadable(lazy(() => import('pages/schedule-posts/youtube')));
const Facebook = Loadable(lazy(() => import('pages/schedule-posts/facebook')));
const LinkedIn = Loadable(lazy(() => import('pages/schedule-posts/linkedin')));
// render - sample page
const SamplePage = Loadable(lazy(() => import('pages/extra-pages/sample-page')));
const Message = Loadable(lazy(() => import('pages/message')));

const PlansRoute = () => {
  const userType = Number(localStorage.getItem('userType'));
  if (userType === 1) {
    return <AdminPlans />;
  } else if (userType === 3 || userType === 4 || userType === 2) {
    return <GeneralPlans />;
  } else {
    return <div>No access to plans</div>;
  }
};


// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (
    <PrivateRoute>
      <DashboardLayout />
    </PrivateRoute>
  ), // ✅ protected layout
  children: [
    {
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        }
      ]
    },
   {
      path: 'schedule-posts',
      children: [
        {
          path: '',
          element: <PrivateRoute><SchedulePostsDefault /></PrivateRoute>
        },
        {
          path: 'instagram',
          element: <PrivateRoute><Instagram /></PrivateRoute>
        },
        {
          path: 'youtube',
          element: <PrivateRoute><YouTube /></PrivateRoute>
        },
        {
          path: 'facebook',
          element: <PrivateRoute><Facebook /></PrivateRoute>
        },
        {
          path: 'linkedin',
          element: <PrivateRoute><LinkedIn /></PrivateRoute>
        }
      ]
    },
    {
      path: 'messages',
      element: (
        
          <Message />
        
      )
    },
    {
      path: 'account',
      element: (
        <PrivateRoute>
          <Account />
        </PrivateRoute>
      )
    },
    {
      path: 'typography',
      element: <Typography />
    },
    {
      path: 'color',
      element: <Color />
    },
    {
      path: 'shadow',
      element: <Shadow />
    },
    {
      path: 'sample-page',
      element: <SamplePage />
    },
    {
      path: 'users',
      element: <UsersPage/>
    },
        {
      path: 'plans',
      element: <PlansRoute />
    },
{
      path: 'platform',
      element: <PlatformPage/>
    },
    {
      path: 'profile',
      element: <Profile />
    },


  ]
};

export default MainRoutes;
